export default __webpack_public_path__ + "efe83aa3b11bdce512b50a66a7ddcb5b.woff";